import Promise from 'es6-promise'
Promise.polyfill();

import "babel-polyfill";


import Lodash from 'lodash';
window._ = Lodash;


import Popper from 'popper.js/dist/umd/popper'
window.Popper = Popper;


try {
    window.$ = window.jQuery = require('jquery');

    require('jquery-validation');
    require('jquery.backstretch');
    require('bootstrap');
    require('jquery.growl');
} catch (e) { }

import Axios from 'axios';

window.axios = Axios;

import Form from './utilities/Form';

window.Form = Form;


import UtilizationCodeChecker from './utilities/UtilizationCodeChecker';

window.UtilizationCodeChecker = UtilizationCodeChecker;


window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';



let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js